import { useState, useEffect } from "react";
import apiClient from "../../services/apiClient";
import { getCookie } from "../../utils/cookies";
import toast from "../../utils/toast";

const DOC_BASE_URL = "https://api.learning2earning.net";

export default function FundRequest() {
  const [walletType, setWalletType] = useState("");
  const [bank, setBank] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [utr, setUtr] = useState("");
  const [requestedAmount, setRequestedAmount] = useState("");
  const [uploadImage, setUploadImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [fundRequestToUsers, setFundRequestToUsers] = useState([]);
  const [isBalanceData, setBalanceData] = useState();
  const [bankList, setBankList] = useState([]);
  const [qrPreviewUrl, setQrPreviewUrl] = useState(null);

  useEffect(() => {
    fetchFundRequestTo();
    fetchBalanceData();
  }, []);

  const fetchBalanceData = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/v2/GetBalance", {
        paymentID: 0,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setBalanceData(res);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const fetchFundRequestTo = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/FundRequestTo", {
        paymentID: 0,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        const users = res.fundRequestToUsers || [];
        setFundRequestToUsers(users);
        if (users.length > 0) {
          fetchBankAndPaymentMode(users[0].parentID);
        }
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const fetchBankAndPaymentMode = async (parentId) => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/GetBankAndPaymentMode", {
        SlabID: "",
        parentid: String(parentId),
        paymentID: 0,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setBankList(res.banks || []);
      } else {
        setBankList([]);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  function handleBankChange(value) {
    setBank(value);
    setPaymentMode("");
    setUtr("");
  }

  function handlePaymentModeChange(value) {
    setPaymentMode(value);
    setUtr("");
  }

  function handleCancel() {
    setWalletType("");
    setBank("");
    setPaymentMode("");
    setUtr("");
    setRequestedAmount("");
    setUploadImage(null);
  }

  async function handleSubmitFundRequest() {
    if (!walletType) {
      toast.error("Please select a wallet type");
      return;
    }
    if (!bank) {
      toast.error("Please select a bank");
      return;
    }
    if (!paymentMode) {
      toast.error("Please select a payment mode");
      return;
    }
    if (!utr.trim()) {
      toast.error("Please enter the UTR");
      return;
    }

    const amount = Number(requestedAmount);
    if (!requestedAmount || isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid requested amount");
      return;
    }

    // if (selectedMode?.isAccountHolderRequired && !selectedBank?.accountHolder) {
    //   toast.error("Account holder name is missing for this bank");
    //   return;
    // }

    setIsSubmitting(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const orderRequest = {
        accountHolderName: selectedBank?.accountHolder || "",
        accountNumber: selectedBank?.accountNo || "",
        amount: requestedAmount,
        bankID: String(selectedBank?.id || ""),
        cardNo: "",
        checksum: "",
        chequeNo: "",
        isImage: uploadImage ? 1 : 0,
        mobileNo: "",
        orderID: "0",
        paymentID: Number(paymentMode),
        transactionID: utr.trim(),
        upiid: "",
        walletTypeID: walletType,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      };

      const formPayload = new FormData();
      if (uploadImage) {
        formPayload.append("file", uploadImage, uploadImage.name);
      }
      formPayload.append("UserFundRequest", JSON.stringify(orderRequest));

      const res = await apiClient.post("/App/AppFundOrder", formPayload, {
        headers: { "Content-Type": undefined },
      });

      if (res.statuscode == 1) {
        toast.success(res.msg);
        handleCancel();
        fetchBalanceData();
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Failed to submit fund request. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  function formatAmount(amount) {
    const num = Number(amount) || 0;
    return `₹${num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const fundProcessWallets = (isBalanceData?.balanceData || []).filter(
    (w) => w.inFundProcess,
  );
  const selectedWallet = fundProcessWallets.find(
    (w) => String(w.id) === walletType,
  );
  const selectedBank = bankList.find((b) => String(b.id) === bank);
  const paymentModeOptions = (selectedBank?.mode || []).filter(
    (m) => m.isActive,
  );
  const selectedMode = paymentModeOptions.find(
    (m) => String(m.id) === paymentMode,
  );

  return (
    <div className="content">
      <section className="page active" id="page-fund-request">
        <h3 className="section-title">Fund Request</h3>
        <div className="card">
          <div className="grid grid-2">
            <div className="field">
              <label>* Wallet Type</label>
              <select
                value={walletType}
                onChange={(e) => setWalletType(e.target.value)}
              >
                <option value="">:: Select Wallet ::</option>
                {fundProcessWallets.map((wallet) => (
                  <option key={wallet.id} value={wallet.id}>
                    {wallet.walletType}
                  </option>
                ))}
              </select>
              <div
                className="field-note"
                style={{ color: "var(--text-faint)" }}
              >
                Wallet Balance:{" "}
                {selectedWallet ? formatAmount(selectedWallet.balance) : "-"}
              </div>
            </div>
            <div className="field">
              <label>* Choose Bank</label>
              <select
                value={bank}
                onChange={(e) => handleBankChange(e.target.value)}
              >
                <option value="">:: Select Bank ::</option>
                {bankList.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.bankName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-2">
            <div className="field">
              <label>Deposit Account</label>
              <input
                type="text"
                value={selectedBank?.accountNo || ""}
                disabled
              />
            </div>
            <div className="field">
              <label>* Choose Payment Mode</label>
              <select
                value={paymentMode}
                onChange={(e) => handlePaymentModeChange(e.target.value)}
                disabled={!bank}
              >
                <option value="">:: Payment Mode ::</option>
                {paymentModeOptions.map((m) => (
                  <option key={m.id} value={m.modeID}>
                    {m.mode}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {paymentMode && (
            <div className="grid grid-2">
              <div className="field">
                <label>* UTR</label>
                <input
                  type="text"
                  placeholder="Enter UTR"
                  value={utr}
                  onChange={(e) => setUtr(e.target.value)}
                />
              </div>
            </div>
          )}

          <div className="grid grid-2">
            <div className="field">
              <label>* Requested Amount</label>
              <input
                type="number"
                placeholder="Enter amount"
                value={requestedAmount}
                onChange={(e) => setRequestedAmount(e.target.value)}
              />
            </div>
            <div className="field">
              <label>Upload Image (Optional)</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => setUploadImage(e.target.files?.[0] || null)}
              />
              {uploadImage && (
                <div
                  className="field-note"
                  style={{ color: "var(--text-faint)" }}
                >
                  {uploadImage.name}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
            <button
              type="button"
              className="btn-primary"
              style={{ width: "auto", padding: "11px 28px" }}
              onClick={handleSubmitFundRequest}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Request"}
            </button>
            <button
              type="button"
              className="btn-sm"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              Cancel
            </button>
          </div>
        </div>

        <h3 className="section-title" style={{ marginTop: 24 }}>
          Bank Details
        </h3>
        <div className="card">
          <div className="table-scroll">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>BankName</th>
                  <th>BranchName</th>
                  <th>AccountHolder</th>
                  <th>AccountNumber</th>
                  <th>IfscCode</th>
                  <th>Billing Info</th>
                  <th>Cash Deposit Charges</th>
                  <th>QR Logo</th>
                  <th>BankLogo</th>
                </tr>
              </thead>
              <tbody>
                {bankList.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="table-empty">
                      No bank details available.
                    </td>
                  </tr>
                ) : (
                  bankList.map((b, idx) => (
                    <tr key={b.id ?? idx}>
                      <td className="mono">{idx + 1}</td>
                      <td className="strong">{b.bankName}</td>
                      <td>{b.branchName}</td>
                      <td>{b.accountHolder}</td>
                      <td className="mono">{b.accountNo}</td>
                      <td className="mono">{b.ifscCode}</td>
                      <td>-</td>
                      <td className="mono">{formatAmount(b.cdmCharges)}</td>
                      <td>
                        {b.qrPath ? (
                          <img
                            src={`${DOC_BASE_URL}/image/BankQR/${b.qrPath}`}
                            alt="QR"
                            onClick={() =>
                              setQrPreviewUrl(
                                `${DOC_BASE_URL}/image/BankQR/${b.qrPath}`,
                              )
                            }
                            style={{
                              width: 32,
                              height: 32,
                              objectFit: "contain",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          "No Image"
                        )}
                      </td>
                      <td>
                        {b.mode?.[0]?.bankID ? (
                          <img
                            src={`${DOC_BASE_URL}/image/BankLogo/${b.mode[0].bankID}.png`}
                            alt={b.bankName}
                            style={{
                              width: 40,
                              height: 40,
                              objectFit: "contain",
                            }}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {qrPreviewUrl && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(6,8,12,0.72)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
          }}
          onClick={() => setQrPreviewUrl(null)}
        >
          <div
            style={{ position: "relative", maxWidth: 360, width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <span
              onClick={() => setQrPreviewUrl(null)}
              style={{
                position: "absolute",
                top: -14,
                right: -14,
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#fff",
                color: "#111",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
              }}
            >
              &times;
            </span>
            <img
              src={qrPreviewUrl}
              alt="Scan QR"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 14,
                display: "block",
                background: "#fff",
                padding: 16,
                boxShadow: "0 40px 100px -30px rgba(0,0,0,0.7)",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
